var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbstract2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 181,
    viewBox: "0 0 249 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_904_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52812 76.2735L3.63192 68.6828C1.75121 61.1541 7.74081 52.2118 18.8332 49.4409L197.916 4.7048C209.268 1.86895 218.588 7.39419 220.505 15.0678L222.23 21.9726L5.52812 76.2735Z",
    fill: "url(#paint0_linear_904_347)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_904_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.541 144.5C147.913 153.974 133.161 157.66 123.738 151.945L11.623 83.9466C-0.282279 76.726 5.06085 60.6331 20.657 56.7371L199.74 12.001C215.336 8.10494 227.619 19.7946 220.508 31.7656L153.541 144.5Z",
    fill: "url(#paint1_radial_904_347)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_904_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.424 22.8706C221.102 14.8243 211.337 9.10333 199.739 12.0004L20.6564 56.7365C9.05899 59.6336 3.13094 69.275 5.74864 76.9975C4.53831 69.6466 10.2963 60.7681 20.9958 58.0953L200.079 13.3592C210.778 10.6864 220.035 15.8141 222.424 22.8706Z",
    fill: "url(#paint2_linear_904_347)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_904_347",
    x: 3.28906,
    y: 3.48244,
    width: 218.941,
    height: 72.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.467387
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.467387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_904_347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_904_347",
    x: 5.13672,
    y: 11.2375,
    width: 217.439,
    height: 143.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.467387
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.467387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "shape",
    result: "effect1_innerShadow_904_347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_904_347",
    x: 4.20194,
    y: 10.3022,
    width: 219.157,
    height: 67.63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.467387,
    result: "effect1_foregroundBlur_904_347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_904_347",
    x1: 219.506,
    y1: 11.066,
    x2: 2.76431,
    y2: 65.2094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681928,
    stopColor: "#DAC46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E979"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_904_347",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.812 68.2433) rotate(165.974) scale(181.205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_904_347",
    x1: 236.816,
    y1: 52.3976,
    x2: 6.93176,
    y2: 109.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white",
    stopOpacity: 0.865636
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract2);
export default __webpack_public_path__ + "static/media/abstract2.64ee4c54524e9e5070510a39e3dbfff3.svg";
export { ForwardRef as ReactComponent };